import { safeParseNullDefault } from 'shouldve-been-js';

class VesselType {

    private _vesselTypeId: string;
    private _vesselType: string;

    public constructor(vesselTypeId: string, vesselType: string) {

        this._vesselTypeId = vesselTypeId;
        this._vesselType = vesselType;
    }

    public get vesselTypeId(): string {
        return this._vesselTypeId;
    }

    public set vesselTypeId(value: string) {
        this._vesselTypeId = value;
    }

    public get vesselType(): string {
        return this._vesselType;
    }

    public set vesselType(value: string) {
        this._vesselType = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): VesselType | null {

        const vesselTypeId: string | null = safeParseNullDefault<string>(json?.vesselTypeId, '');
        const vesselType: string | null = safeParseNullDefault<string>(json?.vesselType, '');

        if (vesselTypeId === null || vesselType === null) {
            return null;
        }
        
        return new VesselType(vesselTypeId, vesselType);
    }
}

export default VesselType;